import { ShiftPublishState } from '@frontend/graphql/types.generated'

import { SlotChip, type ChipVariant } from './SlotChip'

import type { ShiftSlotWithShift } from '../shifts/types'

export function sortAssignedFirst(slots: ShiftSlotWithShift[]): ShiftSlotWithShift[] {
  return [...slots].sort((a, b) => {
    const aAssigned = Boolean(a.supporter)
    const bAssigned = Boolean(b.supporter)
    if (aAssigned === bAssigned) return 0
    return aAssigned ? -1 : 1
  })
}

function chipVariant(publishState: ShiftPublishState, slot: ShiftSlotWithShift): ChipVariant {
  if (publishState === ShiftPublishState.Draft) return 'neutral'
  return slot.published ? 'published' : 'added'
}

type SlotChipsProps = {
  slots: ShiftSlotWithShift[]
  publishState: ShiftPublishState
  onChange: () => void
}

export function SlotChips({ slots, publishState, onChange }: SlotChipsProps) {
  return (
    <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-1.5">
      {sortAssignedFirst(slots).map((slot) => (
        <SlotChip key={slot.id} slot={slot} onChange={onChange} variant={chipVariant(publishState, slot)} />
      ))}
    </div>
  )
}
